import React, { Component } from 'react';
import '../Public/css/footer.scss';
import '../Public/css/footerresponsivedoc.scss';
import { Container } from 'react-bootstrap';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse } from '../../Actions/AllAction';
import { withNamespaces } from 'react-i18next';

function Footer(props) {

    const history = useHistory();
    const { type } = useParams();
    const currentYear = new Date().getFullYear();
    const aboutUs = () => {
        history.push(`/${localStorage.getItem('i18nextLng')}/about-us`);
    }
    const termsConditions = () => {
        history.push(`/${localStorage.getItem('i18nextLng')}/terms-conditions`);
    }
    const faq = () => {
        history.push(`/${localStorage.getItem('i18nextLng')}/faq`);
    }
    const PrivacyPolicy = () => {
        history.push(`/${localStorage.getItem('i18nextLng')}/privacy-policy`);
    }
    const Sitemap = () => {
        history.push(`/${localStorage.getItem('i18nextLng')}/sitemap`);
    }

    let apiKey = localStorage.getItem("api_key") || '';


    return (
        <>
            <div className="footerSec">
                <div className="footerSecTop">
                    <Container>
                        <div className="footerInn">
                            <div className="row">
                                <div className="col-xl-4 col-md-12 col-sm-12">
                                    <div className="footerBox">
                                        <a href="#" className="onlyMob">{apiKey === "" ? <img src={require('../Public/images/logo.png')} className="footerLogo" /> : <img src={props.globalSeoData?.imageUrl || require('../Public/images/logo.png')} className="footerLogo" />}</a>
                                        <p>Users can search for properties based on criteria such as location, check-in/check-out dates, number of guests, and room preferences. <a href="#" className="onlyDesktop">{apiKey === "" ? <img src={require('../Public/images/logo.png')} className="footerLogo" /> : <img src={props.globalSeoData?.imageUrl || require('../Public/images/logo.png')} className="footerLogo" />}</a> Detailed information about each property, including room types, amenities, photos, and reviews.</p>
                                        <p>A mobile-responsive design that ensures the site is accessible and user-friendly on smartphones and tablets.</p>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-md-4 col-sm-6 col-6">
                                    <div className="footerBox">
                                        <ul>
                                            <li><a href="/">Home</a></li>
                                            <li><a><button onClick={() => { aboutUs() }}>About Us</button></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-md-4 col-sm-6 col-6">
                                    <div className="footerBox">
                                        <ul>
                                            <li><a><button onClick={() => { faq() }}>FAQ</button></a></li>
                                            <li><a><button onClick={() => { PrivacyPolicy() }}>Privacy Policy</button></a></li>
                                            <li><a><button onClick={() => { termsConditions() }}>Terms &amp; Conditions</button></a></li>
                                            <li><a><button onClick={() => { Sitemap() }}>Sitemap</button></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-4 col-sm-12">
                                    <div className="footerBox footInfo">
                                        <ul>
                                            <li><strong>Location -</strong>
                                                {apiKey == "" ? `S-129, B.P. Township,` : props.globalSeoData?.org?.address1 ? `${props.globalSeoData?.org?.address1.charAt(0).toUpperCase()}${props.globalSeoData?.org?.address1.substring(1, props.globalSeoData?.org?.address1.length)}` : '' || `S-129, B.P. Township,`}<br />
                                                {apiKey == "" ? `Patuli` : props.globalSeoData?.org?.city ? `${props.globalSeoData?.org?.city.charAt(0).toUpperCase()}${props.globalSeoData?.org?.city.substring(1, props.globalSeoData?.org?.city.length)}` : '' || `Patuli`}, {apiKey == "" ? `Kolkata` : props.globalSeoData?.org?.state ? `${props.globalSeoData?.org?.state.charAt(0).toUpperCase()}${props.globalSeoData?.org?.state.substring(1, props.globalSeoData?.org?.state.length)}` : '' || `Kolkata`}-{apiKey == "" ? `700094` : props.globalSeoData?.org?.zip ? props.globalSeoData?.org?.zip : '' || `700094`}</li>
                                            <li><strong>Contact -</strong><a href="tel:3340705047">+{apiKey == "" ? `91 33 40705047` : props.globalSeoData?.org?.contact_number || `91 33 40705047`}</a></li>
                                            <li><strong>Mail Us -</strong><a href="mailto:connect@mettastay.com">{apiKey == "" ? `connect@mettastay.com` : props.globalSeoData?.org?.email || `connect@mettastay.com`}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-12 col-md-12 col-sm-12">
                                    <p className='information-box'><strong>Disclaimer:</strong> The data, content, and information presented in this demo have been sourced from publicly available websites and are used strictly for demonstration purposes only. We do not claim ownership of the data, nor do we guarantee its accuracy, completeness, or timeliness. If you are the rightful owner of any content displayed here and have any concerns or objections regarding its use, please feel free to contact us at info@mettletech.in/connect@mettastay.com</p>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>


            <div className="footerBottom">
                <div className="container">
                    <div className="footerBtext">
                        {/* <p>Copyright © {currentYear} MettaStay . All Rights Reserved.</p> */}
                        <p>Copyright © {currentYear} {apiKey === "" ? "MettaStay" : `${props.globalSeoData?.pageTitle?.charAt(0)}${props.globalSeoData?.pageTitle?.substring(1,props.globalSeoData?.pageTitle?.length)}`} . All Rights Reserved.</p>
                        <p><span className="content-label">Design & developed by - <a href="https://mettletech.co/" target="_blank">Mettle Tech</a></span></p>
                        <div className='powered-by'>
                            {/* <p>Powered by Tmettastay</p> */}
                            <p><span>Powered by</span> <a href="https://mettastay.com/" target="_blank"><img className="powered-img" src={require('../../Utility/Public/images/logoWhite.png')} /></a></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

// export default (Footer);
const mapStateToProps = (globalState) => {
    console.log("globalSeoData==========",globalState.mainReducerData.globalSeoData)
    return {
        globalSeoData: globalState.mainReducerData.globalSeoData,
    };
}


export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse })
    (withNamespaces()(Footer));